import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class COEStockSummaryReportService {
  constructor(private http: HttpUtilService) {}

  COEStockSummary(model: {
    Type: string;
  }): Observable<HttpResponse<any>> {
    return this.http.post(
      `AutopacReportService.asmx/COEStockSummary`,
      {
        model: model,
      },
    );
  }
}
